import React from "react";
import { SvgIcon, styled } from "@mui/material";

const IconRoot = styled(SvgIcon)(({ textColor }) => ({
  "& .st0": {
    fill: "#00A3DF",
  },
  "& .st1": {
    fill: textColor ?? "#231F20",
  },
  "& .st2": {
    fill: "#909AA0",
  },
}));

const AcuScreenLogo = (props) => {
  return (
    <IconRoot {...props} viewBox="0 0 1326 235">
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M52.2,2.5L3,129.8h30.9l8-21.6h54.6l7.8,21.6h30.9L86.2,2.5H52.2z M49.4,84.3l19.8-54.8l19.8,54.8H49.4z"
            />
            <path
              class="st0"
              d="M186.4,56.9c8.4,0,15.1,3.4,19.5,9.9l15.8-14.9c-6.1-8.4-17.6-16.6-36.4-16.6c-28.4,0-48.9,20-48.9,48.3
                        c0,28.4,20.4,48.5,48.9,48.5c18.9,0,30.3-8.2,36.4-16.8l-15.8-14.7c-4.4,6.1-11.1,9.9-19.5,9.9c-14.7,0-25-10.9-25-26.9
                        S171.7,56.9,186.4,56.9z"
            />
            <path
              class="st0"
              d="M295.5,100c-4.2,5.3-11.6,10.5-21,10.5c-10.3,0-17-4.2-17-17V37.6h-24.2V103c0,17.9,9.5,29,29.8,29
                        c15.1,0,26.1-6.9,32.4-13.9v11.6h24.2V37.6h-24.2V100z"
            />
            <path
              class="st0"
              d="M365,37c0-7.6,6.5-12.8,18.1-12.8c13,0,26.7,4.4,37,13.9l15.1-19.8C422.6,6.7,405.8,0.6,385.6,0.6
                        c-30,0-48.3,17.6-48.3,38.7c0,47.9,73.3,32.4,73.3,55c0,7.3-7.3,14.1-22.1,14.1c-17.6,0-31.5-7.8-40.5-17.2l-14.7,20.6
                        c11.8,12,29.4,20.2,53.8,20.2c34.3,0,51-17.6,51-40.8C438.1,43.7,365,57.2,365,37z"
            />
            <path
              class="st0"
              d="M497.9,56.9c8.4,0,15.1,3.4,19.5,9.9l15.8-14.9c-6.1-8.4-17.6-16.6-36.4-16.6c-28.4,0-48.9,20-48.9,48.3
                        c0,28.4,20.4,48.5,48.9,48.5c18.9,0,30.3-8.2,36.4-16.8l-15.8-14.7c-4.4,6.1-11.1,9.9-19.5,9.9c-14.7,0-25-10.9-25-26.9
                        S483.2,56.9,497.9,56.9z"
            />
            <path
              class="st0"
              d="M569.5,50.2V37.6h-24.2v92.2h24.2V68.9c4-5.9,14.7-10.5,22.7-10.5c2.7,0,5,0.2,6.7,0.6V35.3
                        C587.5,35.3,576,42,569.5,50.2z"
            />
            <path
              class="st0"
              d="M652.3,35.3c-28.1,0-47.7,21.6-47.7,48.3c0,29.6,21.2,48.5,49.2,48.5c14.3,0,28.8-4.4,38-12.8l-10.7-15.7
                        c-5.9,5.7-16.8,9.2-24.6,9.2c-15.7,0-25-9.7-26.5-21.4h68.5v-5.3C698.5,55.9,679.8,35.3,652.3,35.3z M629.6,75
                        c1.1-9.2,7.6-20.4,22.7-20.4c16,0,22.1,11.6,22.7,20.4H629.6z"
            />
            <path
              class="st0"
              d="M755.9,35.3c-28,0-47.7,21.6-47.7,48.3c0,29.6,21.2,48.5,49.2,48.5c14.3,0,28.8-4.4,38-12.8l-10.7-15.7
                        c-5.9,5.7-16.8,9.2-24.6,9.2c-15.7,0-25-9.7-26.5-21.4h68.5v-5.3C802.1,55.9,783.4,35.3,755.9,35.3z M733.2,75
                        c1.1-9.2,7.6-20.4,22.7-20.4c16,0,22.1,11.6,22.7,20.4H733.2z"
            />
            <path
              class="st0"
              d="M873.4,35.3c-15.1,0-26.3,7.3-32.3,14.3v-12h-24.2v92.2h24.2v-62c4-5.5,11.5-10.9,21-10.9
                        c10.3,0,17,4.4,17,17.2v55.7h24.2V64.7C903.4,46.8,893.6,35.3,873.4,35.3z"
            />
          </g>
          <path
            class="st1"
            d="M1292.7,7.2v18.5h-2.7V7.2h-5.9V4.7h14.5v2.5H1292.7z M1319.9,25.7V8.3l-7.2,17.4h-0.8l-7.2-17.4v17.4h-2.7
                    v-21h4.1l6.1,15.3l6.1-15.3h4.1v21H1319.9z"
          />
        </g>
        <g>
          <polygon
            class="st2"
            points="977.9,112.4 935,2.5 916.8,2.5 968,129.8 987.6,129.8 1039,2.5 1020.8,2.5 		"
          />
          <polygon
            class="st2"
            points="1174.7,2.5 1174.7,16.6 1215,16.6 1215,129.8 1230.8,129.8 1230.8,16.6 1271.3,16.6 1271.3,2.5 		"
          />
          <path
            class="st2"
            d="M1105.1-0.2c-36.5,0-66.1,29.6-66.1,66.1c0,36.5,29.6,66.1,66.1,66.1c36.5,0,66.1-29.6,66.1-66.1
                    C1171.2,29.4,1141.6-0.2,1105.1-0.2z M1105.1,116.8c-28.1,0-50.9-22.8-50.9-50.9c0-28.1,22.8-50.9,50.9-50.9
                    c28.1,0,50.9,22.8,50.9,50.9C1156,94,1133.2,116.8,1105.1,116.8z"
          />
          <circle class="st2" cx="1105.1" cy="65.9" r="12.1" />
          <path
            class="st2"
            d="M1110.2,27.3c0-2.8-2.3-5.1-5.1-5.1c-24.1,0-43.6,19.6-43.6,43.6c0,2.8,2.3,5.1,5.1,5.1
                    c2.8,0,5.1-2.3,5.1-5.1c0-18.4,15-33.4,33.4-33.4C1107.9,32.4,1110.2,30.1,1110.2,27.3z"
          />
        </g>
      </g>
      <g>
        <path
          class="st1"
          d="M206.5,234.2l-16.5-41h5.8l13.8,35.4l13.8-35.4h5.8l-16.5,41H206.5z"
        />
        <path class="st1" d="M239.9,234.2v-41h5.1v41H239.9z" />
        <path
          class="st1"
          d="M259.8,234.2v-41h14c12.7,0,21,8.9,21,20.5c0,11.7-8.3,20.4-21,20.4H259.8z M289.6,213.7c0-8.8-5.6-16-15.7-16
                h-8.9v31.9h8.9C283.8,229.6,289.6,222.5,289.6,213.7z"
        />
        <path
          class="st1"
          d="M307.7,234.2v-41h26.8v4.5h-21.7V211h21.3v4.5h-21.3v14.1h21.7v4.5H307.7z"
        />
        <path
          class="st1"
          d="M345.5,213.7c0-12.1,8.2-21.2,20.3-21.2c12.1,0,20.3,9.1,20.3,21.2c0,12.1-8.2,21.2-20.3,21.2
                C353.6,234.9,345.5,225.8,345.5,213.7z M380.8,213.7c0-9.6-5.9-16.6-15-16.6c-9.2,0-15,7.1-15,16.6c0,9.5,5.8,16.6,15,16.6
                C374.9,230.4,380.8,223.3,380.8,213.7z"
        />
        <path
          class="st1"
          d="M418.1,213.7c0-12.1,8.2-21.2,20.3-21.2c12.1,0,20.3,9.1,20.3,21.2c0,12.1-8.2,21.2-20.3,21.2
                C426.3,234.9,418.1,225.8,418.1,213.7z M453.5,213.7c0-9.6-5.9-16.6-15-16.6c-9.2,0-15,7.1-15,16.6c0,9.5,5.8,16.6,15,16.6
                C447.6,230.4,453.5,223.3,453.5,213.7z"
        />
        <path
          class="st1"
          d="M471.8,234.2v-41H490c7.1,0,11.5,4.3,11.5,10.4c0,5.2-3.4,8.6-7.2,9.4c4.4,0.7,8,5.2,8,10.1
                c0,6.6-4.4,11.1-11.9,11.1H471.8z M496.2,204.4c0-3.7-2.5-6.6-7.1-6.6h-12.3V211h12.3C493.8,211,496.2,208.1,496.2,204.4z
                M497,222.6c0-3.7-2.6-7.1-7.6-7.1h-12.5v14.1h12.5C494.2,229.6,497,226.9,497,222.6z"
        />
        <path
          class="st1"
          d="M512.7,228.4l3-3.9c2.7,3,7.1,5.8,12.9,5.8c7.3,0,9.6-3.9,9.6-7.1c0-10.6-24.3-4.7-24.3-19.3
                c0-6.8,6-11.4,14.1-11.4c6.3,0,11.1,2.1,14.6,5.7l-3.1,3.7c-3.1-3.4-7.4-4.9-11.9-4.9c-4.9,0-8.4,2.6-8.4,6.5
                c0,9.2,24.3,3.9,24.3,19.2c0,6-4.1,12-15.1,12C521.3,234.9,516.1,232.2,512.7,228.4z"
        />
        <path
          class="st1"
          d="M556.2,234.2v-41h26.8v4.5h-21.7V211h21.3v4.5h-21.3v14.1h21.7v4.5H556.2z"
        />
        <path
          class="st1"
          d="M619.8,234.2l-10.4-16.3h-8.2v16.3h-5.1v-41h16.5c7.5,0,12.8,4.8,12.8,12.3c0,7.4-5,11.4-10.6,11.9l11.1,16.7
                H619.8z M620.1,205.6c0-4.6-3.3-7.8-8.2-7.8h-10.7v15.7H612C616.8,213.4,620.1,210.2,620.1,205.6z"
        />
        <path
          class="st1"
          d="M650,234.2l-16.5-41h5.8l13.8,35.4l13.8-35.4h5.8l-16.5,41H650z"
        />
        <path
          class="st1"
          d="M683.4,234.2v-41h26.8v4.5h-21.7V211h21.3v4.5h-21.3v14.1h21.7v4.5H683.4z"
        />
        <path
          class="st1"
          d="M723.3,234.2v-41h14c12.7,0,21,8.9,21,20.5c0,11.7-8.3,20.4-21,20.4H723.3z M753,213.7c0-8.8-5.6-16-15.7-16
                h-8.9v31.9h8.9C747.3,229.6,753,222.5,753,213.7z"
        />
        <path
          class="st1"
          d="M802.1,234.2v-36.4h-13v-4.5h31.1v4.5h-13v36.4H802.1z"
        />
        <path
          class="st1"
          d="M860.5,234.2v-18.8h-23.9v18.8h-5.1v-41h5.1v17.6h23.9v-17.6h5.1v41H860.5z"
        />
        <path
          class="st1"
          d="M880.5,234.2v-41h26.8v4.5h-21.7V211h21.3v4.5h-21.3v14.1h21.7v4.5H880.5z"
        />
        <path
          class="st1"
          d="M944.1,234.2l-10.4-16.3h-8.2v16.3h-5.1v-41h16.5c7.5,0,12.8,4.8,12.8,12.3c0,7.4-5,11.4-10.6,11.9l11.1,16.7
                H944.1z M944.4,205.6c0-4.6-3.3-7.8-8.2-7.8h-10.7v15.7h10.7C941.1,213.4,944.4,210.2,944.4,205.6z"
        />
        <path
          class="st1"
          d="M993.2,234.2l-3.6-9.1h-20.4l-3.6,9.1h-5.8l16.5-41h6.3l16.5,41H993.2z M979.4,198.5l-8.7,22H988L979.4,198.5z
                "
        />
        <path
          class="st1"
          d="M1009.6,234.2v-41h16.5c8.2,0,12.8,5.6,12.8,12.3s-4.7,12.3-12.8,12.3h-11.4v16.3H1009.6z M1033.6,205.6
                c0-4.6-3.3-7.8-8.2-7.8h-10.7v15.6h10.7C1030.3,213.4,1033.6,210.2,1033.6,205.6z"
        />
        <path
          class="st1"
          d="M1061.8,234.2v-17.3l-16.1-23.6h6l12.7,19l12.7-19h6l-16.1,23.6v17.3H1061.8z"
        />
      </g>
    </IconRoot>
  );
};

export default AcuScreenLogo;
